/**
 * The toast stack, mounted once: bottom-left, newest at the bottom, as
 * finixt-ui's ToastStack sits. Every toast is custom-rendered, so sonner
 * draws no chrome of its own.
 */
import { Toaster as Sonner } from 'sonner';

export function Toaster() {
  return <Sonner position="bottom-left" offset={20} gap={9} visibleToasts={5} />;
}
